import { Controller as BaseController } from 'stimulus'

/**
 * @namespace Searchv2 SearchLoader
 */
export class Controller extends BaseController {
  static targets = ['searchLoader']

  onResultsLoading() {
    this.showLoader()
  }

  onResultsLoaded() {
    this.hideLoader()
  }

  showLoader() {
    this.searchLoaderTarget?.removeAttribute('hidden')
    this.searchLoaderTarget?.removeAttribute('aria-hidden')
  }

  hideLoader() {
    this.searchLoaderTarget?.setAttribute('hidden', true)
    this.searchLoaderTarget?.setAttribute('aria-hidden', true)
  }
}
